import { Component, Input } from '@angular/core';
import { TestService } from '../../services/test.service';
import { Test } from '../../interfaces/testInterface';
import { RouterLink } from '@angular/router';
import { NgIconComponent } from '@ng-icons/core';
import { PocketbaseService } from '../../services/pocketbase.service';
import { Course } from '../../interfaces/courseInterface';
import { DemoBannerComponent } from "../../components/demo-banner/demo-banner.component";

@Component({
    selector: 'app-exam-start',
    imports: [RouterLink, NgIconComponent, DemoBannerComponent],
    templateUrl: './start.component.html',
    styleUrl: './start.component.scss'
})
export class ExamStartComponent {
  constructor(private testService: TestService, private pocketbaseService: PocketbaseService) { }

  @Input()
  set id(courseOrExamId: string) {
    this.pocketbaseService.pb.collection('courses').getOne<Course>(courseOrExamId)
      .then(course => {
        this.course = course;
        this.startTest(course.exam);
      }).catch(() => {
        // wasnt a course, try exam
        this.startTest(courseOrExamId);
      });
  }

  public test: Test | undefined;
  public course: Course | undefined;

  public startTest(testId: string){
    this.testService.createTest(testId).then((test) => {
      this.test = test;
    });
  }
}
